import { LinkButton } from '@/components/elements/forms/buttons';
import CertificateIcon from '@/components/icons/CertificateIcon';
import { _s } from '@/locale';

export type TCertificate = {
  url?: string;
  name?: string;
  title?: string;
};

const Certificate = (certificate: TCertificate) => {
  return (
    <div className="flex items-center">
      <CertificateIcon className="text-fg_primary mr-xs h-xl w-xl flex-shrink-0 self-start" />
      <LinkButton to={certificate.url} target="_blank" rel="noreferrer" label={certificate.title} className="!p-0" />
    </div>
  );
};

const Certificates = ({
  employees,
}: {
  employees: { id?: number; about?: { name?: string; certificates?: TCertificate[] } }[];
}) => {
  return (
    <div className="details-section">
      <h2 className="mb-xs text-2xl font-semibold">{_s('certificates')}</h2>
      <p className="text-fg_secondary text-sm">{_s('certificatesDescription')}</p>
      <div className="mt-xl gap-x-xs gap-y-xl grid grid-cols-1 md:grid-cols-2">
        {employees.map((employee) => {
          const haveCertificatesWithTitle = employee.about?.certificates?.some((certificate) =>
            /\S/.test(certificate.title),
          );
          if (!haveCertificatesWithTitle) return null;
          return (
            <div key={employee.id}>
              <h3 className="mb-xs text-base font-semibold">
                {_s('practitioner')}: {employee.about.name}
              </h3>
              <div className="space-y-3">
                {[...employee.about.certificates].map((certificate) => {
                  if (/\S/.test(certificate.title)) {
                    return <Certificate key={certificate.url} {...certificate} />;
                  }
                  return null;
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Certificates;
